const getPathWithoutLocale = (path: string): string => {
  const parts = path.split('/').filter(Boolean)
  const hasLocale = parts.length > 0 && parts[0].length === 2
  const pathParts = hasLocale ? parts.slice(1) : parts
  return `/${pathParts.join('/')}`
}

export default defineNuxtRouteMiddleware((to, from) => {
  const hasFromQuery = Object.keys(from.query).length > 0
  const hasToQuery = Object.keys(to.query).length > 0

  if (!hasFromQuery || hasToQuery) {
    return
  }

  const fromPath = getPathWithoutLocale(from.path)
  const toPath = getPathWithoutLocale(to.path)

  if (fromPath !== toPath) {
    return
  }

  return navigateTo({
    path: to.path,
    query: from.query,
    replace: true,
  })
})
